import { useQuery } from '@tanstack/react-query';
import { getCampaignOptions } from '../../lib/api/options';

export function useCampaignOptions(enabled = true) {
  return useQuery({
    queryKey: ['options', 'campaigns'],
    queryFn: getCampaignOptions,
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
